module.exports = __webpack_public_path__ + "assets/img/14.5350a208.png";